import * as React from 'react';
import { EyeIcon, EyeOffIcon, hitSlop, Icon, View } from 'smoothie';

interface ShowPasswordToggleProps {
    showPassword: boolean;
    setShowPassword: (boolean) => void;
}

const ShowPasswordToggle = ({
    showPassword,
    setShowPassword,
}: ShowPasswordToggleProps) => {
    return (
        <View
            height="100%"
            position="absolute"
            right={16}
            onPress={() => {
                setShowPassword(!showPassword);
            }}
            pressStyle={{
                backgroundColor: 'transparent',
                borderWidth: 0,
            }}
            {...hitSlop(8)}
            alignItems="center"
            justifyContent="center"
            cursor="pointer"
        >
            {showPassword ? (
                <Icon icon={EyeIcon} size={20} color="$gray1100" />
            ) : (
                <Icon icon={EyeOffIcon} size={20} color="$gray1100" />
            )}
        </View>
    );
};

export default ShowPasswordToggle;
